import { format, parseISO, startOfMonth, endOfMonth, isValid } from 'date-fns';

/** Format a number as Indian Rupee string: ₹1,23,456 */
export function formatCurrency(amount, showSign = false) {
  if (amount === null || amount === undefined) return '₹0';
  const num = Math.abs(Number(amount));
  const formatted = num.toLocaleString('en-IN', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
  const sign = showSign && amount < 0 ? '-' : '';
  return `${sign}₹${formatted}`;
}

/** Format a date to display string, e.g. "22 Mar 2026" */
export function formatDate(date) {
  if (!date) return '';
  const d = typeof date === 'string' ? parseISO(date) : date;
  if (!isValid(d)) return '';
  return format(d, 'd MMM yyyy');
}

/** Format a date to month-year string, e.g. "March 2026" */
export function formatMonthYear(date) {
  if (!date) return '';
  const d = typeof date === 'string' ? parseISO(date) : date;
  if (!isValid(d)) return '';
  return format(d, 'MMMM yyyy');
}

/** Get ISO date string (yyyy-MM-dd) for today or a given date */
export function toISODate(date = new Date()) {
  return format(date, 'yyyy-MM-dd');
}

/** Parse ISO date string to Date */
export function fromISODate(str) {
  if (!str) return null;
  const d = parseISO(str);
  return isValid(d) ? d : null;
}

/** Get start/end of a given month */
export function getMonthRange(yearMonth) {
  // yearMonth: 'yyyy-MM'
  const d = parseISO(`${yearMonth}-01`);
  return { start: startOfMonth(d), end: endOfMonth(d) };
}

/** Generate list of month strings (yyyy-MM) for the last N months */
export function getLastNMonths(n = 12) {
  const months = [];
  const now = new Date();
  for (let i = 0; i < n; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    months.push(format(d, 'yyyy-MM'));
  }
  return months;
}

/** Get current month string 'yyyy-MM' */
export function currentMonth() {
  return format(new Date(), 'yyyy-MM');
}

/** Format percentage: "86.4%" */
export function formatPercent(value, total) {
  if (!total) return '0%';
  return `${Math.round((value / total) * 100)}%`;
}

/** Truncate long strings */
export function truncate(str, max = 30) {
  if (!str) return '';
  return str.length > max ? `${str.slice(0, max)}…` : str;
}
